// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tips[data-v-65aa544d] {\n  color: #909399;\n  font-size: 12px;\n  line-height: 20px;\n  margin-bottom: 12px;\n}\n.sub-line[data-v-65aa544d] {\n  color: #909399;\n  font-size: 12px;\n}\n.pager[data-v-65aa544d] {\n  margin-top: 12px;\n  text-align: right;\n}\n.selWidthSm[data-v-65aa544d] {\n  width: 130px;\n}\n.selWidth[data-v-65aa544d] {\n  width: 200px;\n}", ""]);
// Exports
module.exports = exports;
